var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('div',{staticClass:"wizard-tab-container",attrs:{"role":"tabpanel","id":_vm.pageId,"aria-hidden":!_vm.active,"aria-labelledby":`step-${_vm.tabId}`}},[_vm._t("default",null,{"active":_vm.active})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }